import { render, staticRenderFns } from "./MsgBox.vue?vue&type=template&id=02f817af&"
import script from "./MsgBox.vue?vue&type=script&lang=js&"
export * from "./MsgBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports